// extracted by mini-css-extract-plugin
module.exports = {"CompaniesBanner":"CompaniesSearchBanner_CompaniesBanner__MQXUY"};